module.exports = __webpack_public_path__ + "static/mighty-12bb426db05355a1103d7e2d3c418100.svg";